// Services
import { HttpService } from "@mgs/ci2019-common/src/services/HttpService";
// Store
import { Store } from "#/store";
// Model
import { ProductCountResponse } from "../common/interfaces/unimog/ProductCountResponse";
import { UnimogProduct } from "../common/interfaces/unimog/UnimogProduct";
import { UnimogPartner } from "../common/interfaces/unimog/UnimogPartner";

export class UnimogService {
  private static _instance;

  public static get instance() {
    if (!this._instance) {
      this._instance = new UnimogService();
    }
    return this._instance;
  }

  private constructor() {}

  private readonly http: HttpService = HttpService.instance;

  public async getCount(
    freitext: string,
    baureihen: string[],
    branchen: string[],
    abh: string,
    fahrzeugtyp: string,
    baumuster: string,
    euronorm: string,
    radstand: string,
    land: string,
    einsatzgebiet: string,
    partnerstatus: string
  ): Promise<ProductCountResponse> {
    let queryUrl = Store.instance.ui.appApiUrl + `unimog/filter/product-count`;

    const response = await this.http.post<ProductCountResponse>(queryUrl, {
      f: {
        q: freitext,
        baureihe: baureihen,
        branche: branchen,
        abh: abh,
        fahrzeugtyp: fahrzeugtyp,
        baumuster: baumuster,
        euronorm: euronorm,
        radstand: radstand,
        land: land,
        einsatzgebiet: einsatzgebiet,
        partnerlevel: partnerstatus,
      },
    });

    return response.body!;
  }

  public async getProductList(
    freitext: string,
    baureihen: string[],
    branchen: string[],
    abh: string,
    fahrzeugtyp: string,
    baumuster: string,
    euronorm: string,
    radstand: string,
    page: number
  ): Promise<UnimogProduct[]> {
    let queryUrl = Store.instance.ui.appApiUrl + `unimog/filter/product`;

    const response = await this.http.post<UnimogProduct[]>(queryUrl, {
      f: {
        q: freitext,
        baureihe: baureihen,
        branche: branchen,
        abh: abh,
        fahrzeugtyp: fahrzeugtyp,
        baumuster: baumuster,
        euronorm: euronorm,
        radstand: radstand,
        page: page,
      },
    });

    return response.body!;
  }

  public async getPartnerList(
    freitext: string,
    baureihen: string[],
    branchen: string[],
    land: string,
    einsatzgebiet: string,
    partnerstatus: string,
    page: number
  ): Promise<UnimogPartner[]> {
    let queryUrl = Store.instance.ui.appApiUrl + `unimog/filter/partner`;

    const response = await this.http.post<UnimogPartner[]>(queryUrl, {
      f: {
        q: freitext,
        baureihe: baureihen,
        branche: branchen,
        land: land,
        einsatzgebiet: einsatzgebiet,
        partnerlevel: partnerstatus,
        page: page,
      },
    });

    return response.body!;
  }

  public async getProduct(
    id: string,
    slug: string | undefined
  ): Promise<UnimogProduct> {
    let queryUrl = Store.instance.ui.appApiUrl + `unimog/product/${id}`;

    const response = await this.http.get<UnimogProduct>(queryUrl, {
      params: { slug },
    });

    return response.body!;
  }

  public async getPartner(
    id: string,
    slug: string | undefined
  ): Promise<UnimogPartner> {
    let queryUrl = Store.instance.ui.appApiUrl + `unimog/partner/${id}`;

    const response = await this.http.get<UnimogPartner>(queryUrl, {
      params: { slug },
    });

    return response.body!;
  }
}
